const CONSTANTS = {
  LOADING: "loading",
  FETCHING: "fetching",
  WARNING: "warning",
  RANDOM: "random",
  STORED: "stored",
  SWITCHTOUS:"switchtous",
  DATA: "DATA",
  LOCAL: "VOICE-LCL",
  INTERNATIONAL: "VOICE-INT",
  ANGHAMI_KEY: "AnghamiPromotion",
  ANGHAMI_TEXTCODE: "%ANGHAMI%",
  FAMILY_PLAN_TEXTCODE: "%FAMILY_PLAN%",
  DATA_ROLLOVER_TEXTCODE:"%DATA_ROLLOVER_TEXTCODE%",
  NON_SET: null,
  RESIDENT: "resident",
  NON_RESIDENT: "non_resident",
  MONEY_BACK_GUARENTEE_REFUND_FAQ_LINK_TEXTCODE: "%REFUND_FAQ%",
  ERROR_APPLE_PAY: "apple_pay_error",
  PAYMENT_METHOD_APPLE: "apple_pay",
  APPLE_PAY_FEATURE: "web_apple_pay",
  PAYMENT_METHOD_CARD: "card",
  ERROR_NO_NUMBER: "no_number_error",
  ERROR_NUMBER_CONFIRM: "number_commit_error",
  ERROR_PAYMENT_AUTHORIZATION: "payment_auth_error",
  ERROR_MERCHANT_VALIDATION: "merchant_validation_error",
};

export default CONSTANTS;
